var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    transform: "rotate(-180 34.5 34.5)",
    fill: "#47BDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0C28.5971 -2.58026e-07 22.7929 1.51459 17.6426 4.39889C12.4923 7.28319 8.16819 11.4407 5.08391 16.4738C1.99964 21.5069 0.258346 27.2472 0.0265983 33.1455C-0.20515 39.0439 1.0804 44.9031 3.76028 50.1627C6.44015 55.4222 10.4247 59.9062 15.3328 63.1857C20.2409 66.4652 25.9084 68.4305 31.7932 68.8936C37.6779 69.3568 43.5831 68.3023 48.9438 65.8309C54.3045 63.3596 58.9414 59.5542 62.4111 54.7786L34.5 34.5L34.5 0Z",
    fill: "#FF7D85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.1a03c6cb3d35b4acdb406a7b70097ca2.svg";
export { ForwardRef as ReactComponent };